// node-modules
import * as Swiper from 'swiper/dist/js/swiper';

// assets
import 'swiper/dist/css/swiper.min.css';
import './swiperSlider.scss';

const sliderOptions = {
  speed: 1000,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2,
  },
  keyboard: true,
};

const addPaginationIfNecessary = (element, config) => {
  const slidesCount = element.querySelectorAll('.swiper-slide').length;
  if (slidesCount > 1) {
    config.pagination = {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: 'true',
    };
  }
  return config;
};

export function studySlider(sliderContainer) {
  return new Swiper(
    sliderContainer.querySelector('[data-role="slider-container"]'),
    {
      ...sliderOptions,
      effect: 'slide',
      spaceBetween: 16,
      slidesPerView: 1,
      slideToClickedSlide: true,
      initialSlide: 1,
      breakpoints: {
        1023: {
          initialSlide: 0,
        },
        639: {
          slidesPerView: 1.1,
          initialSlide: 0,
        },
      },
    },
  );
}

export function programsSlider(sliderContainer) {
  return new Swiper(
    sliderContainer.querySelector('[data-role="slider-container"]'),
    {
      ...sliderOptions,
      effect: 'slide',
      spaceBetween: 32,
      slidesPerView: 2.8,
      slideToClickedSlide: true,
      initialSlide: 0,
      breakpoints: {
        1023: {
          slidesPerView: 2.2,
        },
        768: {
          slidesPerView: 1.7,
        },
        475: {
          slidesPerView: 1.1,
          spaceBetween: 16,
        },
      },
    },
  );
}

export function careersSlider(sliderContainer) {
  const element = sliderContainer.querySelector('[data-role="slider-container"]');
  return new Swiper(
    element,
    addPaginationIfNecessary(element, {
      ...sliderOptions,
      effect: 'slide',
      spaceBetween: 32,
      slidesPerView: 1,
      initialSlide: 0,
      loop: true,
      autoplay: {
        delay: 4000,
      },
      breakpoints: {
        1023: {
          initialSlide: 0,
        },
      },
    }),
  );
}

export function successCareerSlider(sliderContainer) {
  const element = sliderContainer.querySelector('[data-role="slider-container"]');
  return new Swiper(
    element,
    addPaginationIfNecessary(element, {
      ...sliderOptions,
      effect: 'fade',
      slidesPerView: 1,
      initialSlide: 0,
      autoplay: {
        delay: 4000,
      },
    }),
  );
}

export function campusesSlider(sliderContainer) {
  return new Swiper(
    sliderContainer.querySelector('[data-role="slider-container"]'),
    {
      ...sliderOptions,
      effect: 'slide',
      spaceBetween: 148,
      slidesPerView: 2.5,
      initialSlide: 0,
      breakpoints: {
        1199: {
          spaceBetween: 80,
        },
        1023: {
          spaceBetween: 48,
          slidesPerView: 2.3,
        },
        767: {
          spaceBetween: 32,
          slidesPerView: 1.8,
        },
        639: {
          spaceBetween: 32,
          slidesPerView: 1.2,
        },
      },
    },
  );
}

export function postSlider(sliderContainer) {
  const element = sliderContainer.querySelector('[data-role="slider-container"]');
  return new Swiper(element,
    addPaginationIfNecessary(element, {
      ...sliderOptions,
      effect: 'fade',
      slidesPerView: 1,
      initialSlide: 0,
      autoplay: {
        delay: 2000,
      },
    }));
}

export function facultySlider(sliderContainer) {
  return new Swiper(
    sliderContainer.querySelector('[data-role="slider-container"]'),
    {
      ...sliderOptions,
      effect: 'slide',
      slidesPerView: 3.6,
      initialSlide: 0,
      spaceBetween: 32,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1023: {
          slidesPerView: 2,
        },
        640: {
          slidesPerView: 1.5,
        },
      },
    },
  );
}

export function imagesGridSlider(sliderContainer) {
  return new Swiper(
    sliderContainer.querySelector('[data-role="slider-container"]'),
    {
      ...sliderOptions,
      effect: 'slide',
      slidesPerView: 2.6,
      initialSlide: 0,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 2.3,
        },
        640: {
          slidesPerView: 1.5,
        },
      },
    },
  );
}

export function detailSlider(sliderContainer) {
  const element = sliderContainer.querySelector('[data-role="slider-container"]');
  return new Swiper(element,
    addPaginationIfNecessary(element, {
      ...sliderOptions,
      effect: 'fade',
      slidesPerView: 1,
      initialSlide: 0,
      autoplay: {
        delay: 3000,
      },
    }));
}

export function gallerySlider() {
  const galleryThumbs = new Swiper('[data-role="slider-thumbs"]', {
    spaceBetween: 32,
    slidesPerView: 4.4,
    freeMode: true,
    direction: 'horizontal',
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      900: {
        slidesPerView: 3.4,
      },
      640: {
        slidesPerView: 2.3,
      },
      450: {
        slidesPerView: 2.3,
        spaceBetween: 16,
      },
    },
  });
  const productTop = new Swiper('[data-role="slider-gallery-post"]', {
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.product-top-swiper-button-next',
      prevEl: '.product-top-swiper-button-prev',
    },
    spaceBetween: 10,
    thumbs: {
      swiper: galleryThumbs,
    },
  });

  document.querySelectorAll('[data-role="slider-gallery-post"] > .swiper-wrapper img').forEach((img) => {
    img.addEventListener('load', () => productTop.update());
  });
}

export function alumniListSlider(sliderContainer) {
  return new Swiper(
    sliderContainer.querySelector('[data-role="slider-container"]'),
    {
      ...sliderOptions,
      effect: 'slide',
      slidesPerView: 'auto',
      navigation: {
        prevEl: '[data-swiper-prev]',
        nextEl: '[data-swiper-next]',
      },
      spaceBetween: 40,
      breakpoints: {
        1024: {
          spaceBetween: 16,
        },
      },
    },
  );
}
